// extracted by mini-css-extract-plugin
module.exports = {"description":"style__description__H7C8p","characters":"style__characters__4xhOd"};